export const LOGIN_CONSTANTS = {
	USER: "user",
};
